
<app-thankyou-success-head [config]="config"></app-thankyou-success-head>

<div [class.for-inline]="true">
  <!-- static impact selection -->
  <!-- dont remove this code -->
  <div class="static-impact-section">
    <app-sip-static-impact [config]="config" [hideInfo]="true"></app-sip-static-impact>
  </div>

  <!-- sip month plan selection -->
  <div class="plan-form" [class.v1]="true">
    <app-sip-month-plan-v3 [config]="config"></app-sip-month-plan-v3>
  </div>
</div>

<!-- Power of monthly giving -->
<div class="power-of-monthly-giving">
  <app-donors-slider [currency]="config?.order?.iso_currency" [rasiedFr]="false"></app-donors-slider>
</div>


<!-- Donor Testemonials  -->
<div class="donor-testimonials">
  <app-thankyou-testimonials></app-thankyou-testimonials>
</div>

<div class="trusted-by">
  <app-trusted-by [trustedByHosptial]="true"></app-trusted-by>
</div>


<!--faqs-->
<div class="faqs portfolio">
  <div class="title">FAQs</div>
  <app-faqs page="portfolio"></app-faqs>
</div>
